/*
* @描述: 商机首页
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/24 09:37
*/
<template>
    <PullContainer ref="pullContainerRef" :pullDownLabel="true" :pullDownLoading="false">
        <template #container>
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="true" :isTitleNormal="true" title="返回"></ReturnNavBar>
                    <span v-if="activeBusiness['project.edit']||hasDelPermission" class="handle_icon_wrap"
                          @click="handleClickAddBusiness">
                        <i class="iconfont icon-a-tianjiamiaobian"></i>
                    </span>
                </div>
                <div class="top_search">
                    <van-search v-model="searchForm.keyword"
                                placeholder="请输入查询内容"
                                @clear="onSearch"
                                @search="onSearch">
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <ul v-infinite-scroll="scrollLoadList" class="business_list">
                        <li v-for="(row, index) in businessTableList" :key="index" class="business_item">
                            <div class="business_item_header">
                                <div class="business_item_title" @click="handleClickBusinessDetail(row)">
                                    <i class="iconfont icon-shangji1"></i>
                                    <span v-text="row.name.value"></span>
                                </div>
                                <span class="handle_icon_wrap" @click="handleClickBusinessHandle(row)">
                                    <i class="iconfont el-icon-more"></i>
                                </span>
                            </div>
                            <div class="business_item_content">
                                <div class="flex_wrap mb_8">
                                    <div class="form_item_label">客户：</div>
                                    <div class="form_item_value" v-text="row.customer_id.text"></div>
                                </div>
                                <div class="flex_wrap">
                                    <div class="form_item_label">负责人：</div>
                                    <div class="form_item_value custom_contact_field_wrap">
                                        <PersonnelCard :userId="row.uid">
                                            <template slot="container">
                                                <img :src="row.salesperson_avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.salesperson_name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="businessTableList.length >= pagination.total" class="ta_c">--已经到底了--</li>
                    </ul>
                </div>
                <FooterTabbar :tabBarActive="tabBarActive" :tabBarList="tabBarList"></FooterTabbar>
                <van-overlay v-if="handleRadioPicker"
                             :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                             :show="handleRadioPicker"
                             z-index="1000"
                             @click="handleRadioPicker = false">
                    <div class="custom_radio_option_wrap">
                        <ul class="radio_option_list">
                            <li v-if="activeBusiness.approval_status===1&&activeBusiness['project.edit']"
                                class="radio_option_item"
                                @click="handleClickEditBusiness">编辑
                            </li>
                            <li v-if="activeBusiness.is_release===1&&activeBusiness.approval_status===1&&activeBusiness.project_stage.value>0&&activeBusiness['project.edit']"
                                class="radio_option_item"
                                @click="handleClickAdvanceNextStage">推进阶段
                            </li>
                            <li v-if="activeBusiness.is_release===1&&activeBusiness.approval_status===1&&activeBusiness['project.edit']"
                                class="radio_option_item"
                                @click="handleClickChangeThePerson">更换负责人
                            </li>
                            <li v-if="activeBusiness.is_release===1&&activeBusiness.approval_status===1&&activeBusiness['project.edit']"
                                class="radio_option_item"
                                @click="handleClickAddNewQuotation">新增报价
                            </li>
                            <li v-if="activeBusiness.is_release===1&&activeBusiness.approval_status===1&&activeBusiness['project.edit']"
                                class="radio_option_item"
                                @click="handleClickAddMember">添加成员
                            </li>
                            <li v-if="hasDelPermission"
                                class="radio_option_item"
                                @click="handleClickDelBusiness">删除
                            </li>
                        </ul>
                        <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                    </div>
                </van-overlay>
                <ListAdvancedFiltering
                        v-if="searchPopupShow"
                        ref="listAdvancedFiltering"
                        :field_form="'projects'"
                        :system_fields="systemFilterFields"
                        @sendFilterData="getFilterData"/>
                <businessAdd v-if="addBusinessDialogVisible"
                             :dialogVisible.sync="addBusinessDialogVisible"
                             @refresh-list="onSearch"/>
                <businessEdit v-if="editBusinessDialogVisible"
                              :dialogVisible.sync="editBusinessDialogVisible"
                              :project_id="activeBusiness.project_id"
                              @refresh-list="onSearch"/>
                <changeThePerson v-if="changeThePersonDialogVisible"
                                 :project_ids="project_ids"
                                 :dialogVisible.sync=" changeThePersonDialogVisible"
                                 @refresh="onSearch"/>
                <van-popup v-if="stageTaskDialogVisible"
                           v-model="stageTaskDialogVisible"
                           :style="{ width: '100%',height: '100%' }">
                    <div class="public_container">
                        <div class="returnNavBar">
                            <ReturnNavBar :isAllFunctions="false"
                                          :isCustomReturnEvent="true"
                                          :isTitleNormal="true"
                                          title="返回"
                                          @returnEvent="handleClickStageTaskDialogCancel"></ReturnNavBar>
                        </div>
                        <div class="detail_wrap_container pt_10">
                            <CustomFormMobile ref="stage_task_form"
                                              :field_list="stageTaskFieldsList"
                                              :form_detail="stageTaskFieldsFormDetail"
                                              :is_form_module="true"
                                              :pk_id="currentProjectStageId"
                                              @submit-form="submitTaskFormData"/>
                        </div>
                        <div class="add_footer_wrap">
                            <van-button :disabled="btnDisabled"
                                        size="large"
                                        type="primary"
                                        @click="handleClickStageTaskDialogConfirm">提交
                            </van-button>
                        </div>
                    </div>
                </van-popup>
                <addMember v-if="addMemberDialogVisible"
                           :project_ids="project_ids"
                           :dialogVisible.sync="addMemberDialogVisible"
                           @refresh="onSearch"/>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import PullContainer from "@/components/mComponents/PullContainer";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar";
import FooterTabbar from "@/components/mComponents/FooterTabbar";
import {pagination} from "@/mixins";
import {mapState, mapGetters} from "vuex";
import {getAutoSaveStagePushInfo, groupGetStageAndTask, projectDel, projectList, stagePush} from "@/api";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import businessAdd from "./component/business_add";
import businessEdit from "./component/business_edit";
import changeThePerson from "./component/change_the_person"
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile.vue";
import addMember from "./component/add_member";

export default {
    name: "Business",
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shangji1",
                    activeIcon: "icon-shangjixuanzhong",
                    routerName: "Business",
                    title: "商机",
                },
                {
                    icon: "icon-baojiadan1",
                    activeIcon: "icon-baojiadanxuanzhong",
                    routerName: "Quotation",
                    title: "报价",
                },
            ],
            tabBarActive: 0,
            searchForm: {
                keyword: '',
            },
            defaultImg: require('@/assets/images/default.jpg'),
            custom_filter: [],
            systemFilterFields: [],
            businessTableList: [],
            addBusinessDialogVisible: false,
            editBusinessDialogVisible: false,
            activeBusiness: {},
            handleRadioPicker: false,
            stageTaskDialogVisible: false,
            changeThePersonDialogVisible: false,
            project_ids: [],
            btnDisabled: false,
            stageTaskFieldsList: [],
            stageTaskFieldsFormDetail: {},
            nextStageId: 0,
            currentProjectStageId: 0,
            addMemberDialogVisible: false,
        }
    },
    components: {
        CustomFormMobile,
        addMember,
        approveProcessSelect,
        CustomFormDetailPc,
        ListAdvancedFiltering,
        PersonnelCard,
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        businessAdd,
        businessEdit,
        changeThePerson
    },
    computed: {
        ...mapState(["searchPopupShow"]),
        ...mapGetters(['hasPermission']),
        hasDelPermission() {
            return this.hasPermission('project.del', 'customer', 'Project');
        },
    },
    mixins: [pagination],
    created() {
        this.getBusinessTableList()
    },
    mounted() {

    },
    methods: {
        getBusinessTableList() {
            this.loading = true
            projectList({
                page: this.pagination.pageNum,
                size: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.businessTableList = this.businessTableList.concat(data)
                    this.pagination.total = total
                }
                this.loading = false
            })
        },

        onSearch() {
            this.pagination.pageNum = 1
            this.businessTableList = []
            this.getBusinessTableList()
        },

        //滚动加载列表
        scrollLoadList() {
            if (this.businessTableList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getBusinessTableList()
            }
        },

        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },

        getFilterData(data) {
            this.custom_filter = data
            this.onSearch()
        },

        //新增商机事件
        handleClickAddBusiness() {
            this.addBusinessDialogVisible = true
        },

        //点击订单更多操作
        handleClickBusinessHandle(row) {
            this.activeBusiness = row
            this.handleRadioPicker = true
        },

        //点击编辑商机
        handleClickEditBusiness() {
            this.editBusinessDialogVisible = true
        },

        //点击查看商机详情
        handleClickBusinessDetail({project_id, name}) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name.value,
                },
            });
        },

        //点击推进阶段
        handleClickAdvanceNextStage() {
            groupGetStageAndTask({
                project_group_id: this.activeBusiness.project_group_id
            }).then(res => {
                if (res.code === 200) {
                    const currentStage = res.data.find(item => item.project_stage_id === this.activeBusiness.project_stage.value) || {}
                    if (currentStage && currentStage.sort === res.data.length) return this.$toast.fail('已经是最后一阶段，无法推进')
                    this.currentProjectStageId = currentStage.project_stage_id
                    this.project_id = this.activeBusiness.project_id
                    this.nextStageId = res.data[currentStage.sort].project_stage_id
                    if (currentStage.tasks && currentStage.tasks.length) {
                        const field = {
                            field_form: "projects",
                            field_key: currentStage.project_stage_id,
                            field_name: currentStage.name + '任务',
                            field_type: "form_module",
                            extend: {
                                is_form_show: true
                            },
                            sort: currentStage.sort,
                            _child: currentStage.tasks
                        }
                        this.stageTaskFieldsList = [field]
                        if (this.stageTaskFieldsList.length) {
                            getAutoSaveStagePushInfo({
                                project_id: this.activeBusiness.project_id,
                                project_stage: currentStage.project_stage_id,
                            }).then(res => {
                                if (res.code === 200) {
                                    field._child.forEach(child => {
                                        if (this.activeBusiness.hasOwnProperty(child.field_key)) {
                                            this.$set(this.stageTaskFieldsFormDetail, child.field_key, this.activeBusiness[child.field_key])
                                        }
                                        if (res.data && res.data.hasOwnProperty(child.field_key)) {
                                            const field_value = res.data[child.field_key]
                                            if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' && field_value.value !== undefined && field_value.value.length !== 0))) {
                                                this.$set(this.stageTaskFieldsFormDetail, child.field_key, field_value)
                                            }
                                        }
                                    })
                                    this.stageTaskDialogVisible = true
                                }
                            })
                        }
                    } else {
                        stagePush({
                            project_id: this.project_id,
                            project_stage: this.nextStageId,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$toast.success('推进成功')
                                this.getBusinessTableList()
                                this.handleClickStageTaskDialogCancel()
                            }
                        })
                    }
                }
                this.loading = false
            })
        },

        //商机推进弹窗取消
        handleClickStageTaskDialogCancel() {
            this.stageTaskDialogVisible = false
            this.nextStageId = 0
            this.stageTaskFieldsList = []
            this.stageTaskFieldsFormDetail = {}
        },

        //商机推进弹窗确定
        handleClickStageTaskDialogConfirm() {
            this.$refs.stage_task_form.handleClickPublish()
        },

        submitTaskFormData(data) {
            stagePush({
                project_id: this.project_id,
                project_stage: this.nextStageId,
                ...data
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('推进成功')
                    this.getBusinessTableList()
                    this.handleClickStageTaskDialogCancel()
                }
            })
        },

        //点击更换负责人
        handleClickChangeThePerson() {
            this.project_ids = [this.activeBusiness.project_id]
            this.changeThePersonDialogVisible = true
        },

        //点击新增报价
        handleClickAddNewQuotation() {
            this.addQuotationDialogVisible = true
        },

        //点击添加成员
        handleClickAddMember() {
            this.project_ids = [this.activeBusiness.project_id]
            this.addMemberDialogVisible = true
        },

        //点击删除商机
        handleClickDelBusiness() {
            this.$dialog.confirm({
                title: '您确定要删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonColor: '#E44144',
            }).then(() => {
                projectDel({
                    project_id: [this.activeBusiness.project_id]
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('删除成功')
                        this.onSearch()
                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },
    },
}
</script>
<style lang="scss" scoped>
.mobile_container {
    overflow-y: hidden;

    .business_list {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        padding: 10px 16px;

        .business_item {
            margin-bottom: 10px;
            background: #FFFFFF;
            padding: 12px;

            .business_item_header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;

                .business_item_title {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    color: #2990FF;
                }
            }

            .business_item_content {
                .form_item_label {
                    font-size: 12px;
                    line-height: 18px;
                    color: #999999;
                }

                .form_item_value {
                    font-size: 12px;
                    line-height: 18px;
                    color: #666666;
                }
            }
        }
    }
}
</style>